module.exports = __webpack_public_path__ + "img/upload-photo.5705a56b.png";